import React from "react";
import { useTranslation } from "react-i18next";
import { cookiePolicyTrns } from "src/page-components/cookie-policy/trns";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { COOKIE_POLICY_BLOCKS } from "src/page-components/cookie-policy/constants";
import { TextBlock } from "src/components/Typography/TextBlock";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const CookiePolicy = () => {
  const { t } = useTranslation();

  return (
    <MetadataWrapper name="cookie_policy">
      <PageWrapper mainClassName="flex flex-col mt-19">
        <div className="container py-20">
          <h1 className="text-28 font-semibold mb-10">
            {t(cookiePolicyTrns.title)}
          </h1>
          <div className="max-w-200 flex flex-col gap-10">
            {COOKIE_POLICY_BLOCKS.map((block) => (
              <TextBlock key={block.id} {...block} />
            ))}
          </div>
        </div>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default CookiePolicy;
